const allowedTags = new Set(["P", "BR", "H1", "H2", "H3", "H4", "H5", "H6", "STRONG", "B", "EM", "I", "U", "S", "UL", "OL", "LI", "BLOCKQUOTE", "A", "IMG", "HR", "PRE", "CODE"]);

export default function sanitizeHtml(input = "") {
  const source = String(input);
  const container = document.createElement("div");
  container.innerHTML = source.includes("<") ? source : source.split("\n").map((line) => "<p>" + escapeHtml(line) + "</p>").join("");
  const clean = (node) => {
    Array.from(node.children).forEach((child) => {
      if (!allowedTags.has(child.tagName)) {
        child.replaceWith(...Array.from(child.childNodes));
        return;
      }
      Array.from(child.attributes).forEach((attribute) => {
        const name = attribute.name.toLowerCase();
        const value = attribute.value;
        const keep = (child.tagName === "A" && ["href", "title", "target", "rel"].includes(name)) || (child.tagName === "IMG" && ["src", "alt", "width", "height"].includes(name));
        if (!keep || ((name === "href" || name === "src") && !/^(https?:|mailto:|\/)/i.test(value))) child.removeAttribute(attribute.name);
      });
      if (child.tagName === "A") { child.target = "_blank"; child.rel = "noreferrer"; }
      clean(child);
    });
  };
  clean(container);
  return container.innerHTML;
}

function escapeHtml(value) { return value.replace(/[&<>"']/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[character])); }
